import React, { useState, useEffect, useCallback } from "react";
import Modal from "react-modal";
import styles from "./PopUpBanner.module.scss";
import { isBannerHidden, setBannerHidden } from "utils/popupBannerStorage";

const PopUpBanner = ({ onClose, showDontShowToday = true, data }) => {
    const [isOpen, setIsOpen] = useState(false);

    // data가 없으면 안전하게 처리 (optional chaining 사용)

    const image_url = data?.image_url;
    const link = data?.link_url;

    useEffect(() => {
        // 공지 id별로 24시간 안보기 체크
        const bannerId = data?.id;
        if (!bannerId) {
            setIsOpen(true);
            return;
        }

        // 24시간 내에 안보기로 설정되지 않았으면 표시
        if (!isBannerHidden(bannerId)) {
            setIsOpen(true);
        }
    }, [data?.id]);

    const handleClose = useCallback(() => {
        // 닫기 버튼 클릭 시 팝업만 닫기 (24시간 안보기 설정 안함)
        setIsOpen(false);
        if (onClose) {
            onClose();
        }
    }, [onClose]);

    const handleDontShowToday = useCallback(() => {
        // 공지 id별로 24시간 동안 안보기로 설정
        const bannerId = data?.id;
        if (bannerId) {
            setBannerHidden(bannerId);
        }
        handleClose();
    }, [handleClose, data?.id]);

    if (!image_url) return null;

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={handleClose}
            className={styles.modal}
            overlayClassName={styles.overlay}
            ariaHideApp={false}
            onAfterOpen={() => (document.body.style.overflow = "hidden")}
            onAfterClose={() => (document.body.style.overflow = "unset")}
        >
            <div className={styles.container}>
                <div
                    className={styles.imageContainer}
                    onClick={() => {
                        link && window.open(link, "_blank");
                    }}
                >
                    <img
                        src={image_url}
                        alt="광고 배너"
                        className={styles.image}
                    />
                </div>
                <div className={"btn-wrap-flex gap-10"}>
                    <button
                        className={`btn btn-full ${styles.dontShowButton} `}
                        onClick={handleDontShowToday}
                    >
                        오늘 그만보기
                    </button>
                    <button
                        className={`btn btn-full  ${styles.closeButton}`}
                        onClick={handleClose}
                    >
                        닫기
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default PopUpBanner;
